import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/img/gtr-white-16x42.png'
import _imports_1 from '../assets/img/gtr-black-16x42.png'


const _hoisted_1 = { class: "col small lh-sm mb-2" }
const _hoisted_2 = { class: "small" }
const _hoisted_3 = { class: "small" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createTextVNode(" Powered by ", -1)),
      _cache[2] || (_cache[2] = _createElementVNode("img", {
        class: "d-none d-md-inline",
        src: _imports_0,
        alt: "Genera Tu Riqueza",
        title: "Genera Tu Riqueza"
      }, null, -1)),
      _cache[3] || (_cache[3] = _createElementVNode("img", {
        class: "d-md-none",
        src: _imports_1,
        alt: "Genera Tu Riqueza",
        title: "Genera Tu Riqueza"
      }, null, -1)),
      _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
      _createElementVNode("span", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("i", { class: "far fa-copyright" }, null, -1)),
        _createTextVNode(" 2021 - " + _toDisplayString(new Date().getFullYear()), 1)
      ])
    ])
  ]))
}